module.exports = __webpack_public_path__ + "institutovai.jpg?83a7c2dc90e3cf1121de4d842dfc761e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/institutovai.jpg
// module id = 122
// module chunks = 0